import * as ng from 'angular';
import { PreviewService } from '../../../services/preview.service';

class FatturazioneController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any
    ) {
        $rootScope.accepted = false;
        $scope.pageHeader = 'Tipologia fattura';
    }

}

export const FatturazioneComponent: ng.IComponentOptions = {
    template: require('./fatturazione.html'),
    controller: FatturazioneController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione.ts